// frontend/src/StoreLocator/ScopePicker.jsx — "Applies to": all stores, a tag or one store. Shared by Special hours and Notifications.
import React, { useEffect, useState } from 'react';
import { Select } from '@shopify/polaris';
import { slApi } from './apiClient';

export default function ScopePicker({ value, onChange, tags }) {
  const [locs, setLocs] = useState([]);
  useEffect(() => { slApi.locations().then((r) => setLocs(r.locations)).catch(() => {}); }, []);
  return (
    <>
      <Select label="Applies to" value={value.scope} onChange={(v) => onChange({ ...value, scope: v })} options={[{ value: 'all', label: 'All stores' }, { value: 'tag', label: 'Stores with a tag…' }, { value: 'location', label: 'One store…' }]} />
      {value.scope === 'tag' && <Select label="Tag" value={value.tag || ''} onChange={(v) => onChange({ ...value, tag: v })} options={[{ value: '', label: 'Choose…' }, ...(tags || []).map((t) => ({ value: t.title, label: t.title }))]} />}
      {value.scope === 'location' && <Select label="Store" value={String(value.location_id || '')} onChange={(v) => onChange({ ...value, location_id: Number(v) || null })} options={[{ value: '', label: 'Choose…' }, ...locs.map((l) => ({ value: String(l.id), label: l.name }))]} />}
    </>
  );
}
